<script setup lang="ts">
  import { useStepWizard } from "@/lib/useStepWizard"
  import ProgressCard from "@/components/cards/progress-card/ProgressCard.vue"
  import { Button } from "@/components/ui/button"

  defineProps<{
    title: string
    allowSkip?: boolean
    hideFooter?: boolean
    hideProgress?: boolean
    focusOnMount?: boolean
  }>()

  const { progress, goNext, goBack, isFirstStep, steps, modelValue } =
    useStepWizard()
</script>

<template>
  <ProgressCard
    :title="title"
    :progress="progress"
    :hide-progress="hideProgress"
    :focus-on-mount="focusOnMount"
  >
    <slot />

    <template v-if="!hideProgress" #supporting_title>
      Step {{ modelValue + 1 }} of {{ steps.length }}
    </template>

    <template v-if="!hideFooter" #footer>
      <slot name="footer">
        <Button
          v-if="!isFirstStep"
          type="button"
          variant="outline"
          size="md"
          @click.stop="goBack"
        >
          Back
        </Button>
        <slot v-if="allowSkip" name="skip_button">
          <Button variant="text" size="md" @click="goNext">Skip For Now</Button>
        </slot>
        <slot name="next_button">
          <Button variant="tonal" size="md" @click="goNext">Next</Button>
        </slot>
      </slot>
    </template>
  </ProgressCard>
</template>
